module.exports = __webpack_public_path__ + "img/软件服务智慧政务1.3a07309b.png";